export default {
      id: "minus-usage",
      viewBox: "0 0 11 2",
      url: __webpack_public_path__ + "sprite.1790164512331.svg#minus-usage",
      toString: function () {
        return this.url;
      }
    }